import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Title from '../../../components/Title';
import Breadcrumbs from '../../../components/Breadcrumbs';
import CategoryFilter from './dataGrid/CategoryFilter';
import CategoryDataGrid from './dataGrid/CategoryDataGrid';
import * as Selectors from '../redux/categorySelectors';
import * as Actions from '../redux/categoryActions';
import SnackbarSettings from '../../../components/Snackbar/SnackbarSettings';
import * as CommonSelectors from '../../../shared/redux/commonSelectors';
import useDataGridProgressContext from '../../../components/progress/DataGridProgress/context/DataGridProgressContext';

const breadcrumbs = [
  {
    label: 'category.list',
    to: null,
  },
];

const CategoryList: React.FC = () => {
  const { t } = useTranslation();
  const apiRequestState = useSelector(Selectors.apiCategoriesRequestState);
  const apiRequestError = useSelector(Selectors.apiCategoriesRequestError);
  const rootCategory = useSelector(CommonSelectors.rootCategory);
  const dataGridProgressContext = useDataGridProgressContext();

  return (
    <>
      <SnackbarSettings
        hideSuccessMessage={true}
        apiRequestState={apiRequestState}
        apiRequestError={apiRequestError}
        setApiRequestState={Actions.setApiCategoriesRequestState}
        onError={() => {
          dataGridProgressContext.hide();
        }}
      />
      <Title>{t('category.list')}</Title>
      <Breadcrumbs title="category.list" links={breadcrumbs} hide />
      <CategoryFilter categoryId={rootCategory ? (rootCategory.value as unknown as number) : undefined} />
      <CategoryDataGrid />
    </>
  );
};

export default CategoryList;
